export class Budget {
    id: number;
    recieverId: number;
    amount: number;
    type: string;
    releasedById: number;
    dateRecieved: string;
    remarks: string;
    
    reciever: string; //for display only
    releasedBy: string; //for display only

    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
}


// WEBPACK FOOTER //
// ./src/app/models/budgets/budget.ts